import { render, staticRenderFns } from "./RedeemLog.vue?vue&type=template&id=ab22c878&"
import script from "./RedeemLog.vue?vue&type=script&lang=js&"
export * from "./RedeemLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports